import { createStorageAtomFactory } from '@exodus/atoms'

export const eventLogAtomDefinition = {
  id: 'eventLogAtom',
  type: 'atom',
  factory: (deps) =>
    createStorageAtomFactory(deps)({
      key: 'data',
      defaultValue: [],
      isSoleWriter: true,
    }),
  dependencies: ['storage', 'logger'],
  public: true,
}
